/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewclosingpt4Inputs */

const en_letterpreviewclosingpt4 = /** @type {(inputs: Letterpreviewclosingpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguardo a vossa resposta no prazo de uma semana, pelos canais habituais (mensagem, e-mail, ou contacto directo), de modo a podermos resolver esta questão de forma directa.`)
};

const pt_letterpreviewclosingpt4 = /** @type {(inputs: Letterpreviewclosingpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguardo a vossa resposta no prazo de uma semana, pelos canais habituais (mensagem, e-mail, ou contacto directo), de modo a podermos resolver esta questão de forma directa.`)
};

/**
* | output |
* | --- |
* | "Aguardo a vossa resposta no prazo de uma semana, pelos canais habituais (mensagem, e-mail, ou contacto directo), de modo a podermos resolver esta questão de ..." |
*
* @param {Letterpreviewclosingpt4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewclosingpt4 = /** @type {((inputs?: Letterpreviewclosingpt4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewclosingpt4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewclosingpt4(inputs)
	return pt_letterpreviewclosingpt4(inputs)
});
export { letterpreviewclosingpt4 as "letterPreviewClosingPT" }